import { Button, AddIcon } from './AddButton.style'

interface AddButtonProps {
  title: string
  onClick?: () => any
  color?: 'primary' | 'secondary'
}

const AddButton = ({ onClick, title, color = 'primary' }: AddButtonProps) => (
  <Button onClick={onClick} startIcon={<AddIcon />} color={color}>
    {title}
  </Button>
)

export default AddButton
